export default __webpack_public_path__ + "static/topCompany-65613e0e9cdfcc5210c04fa8a757c647.png";